module.exports = __webpack_public_path__ + "static/media/G-9.4f539e11.jpg";